import {Component, Input, OnInit} from '@angular/core';
import {EstimationResult} from '../estimation.result.model';
import isNumber from 'is-number';

@Component({
  selector: 'app-estimation-result',
  templateUrl: './estimation-result.component.html',
  styleUrls: ['./estimation-result.component.css']
})
export class EstimationResultComponent implements OnInit {

  @Input()
  estimationResults: Array<EstimationResult>;
  @Input()
  showVin: boolean;

  constructor() {
  }

  ngOnInit(): void {
  }

  result(estimationResult: EstimationResult): string {
    return estimationResult.message === 'SUCCESS' ? 'calculated' : this.error(estimationResult);
  }

  error(estimationResult): string {

    if (estimationResult.twelveMonthsMessage) {
      return estimationResult.twelveMonthsMessage;
    }

    if (estimationResult.twentyFourMonthsMessage) {
      return estimationResult.twentyFourMonthsMessage;
    }

    if (estimationResult.thirtySixMonthsMessage) {
      return estimationResult.thirtySixMonthsMessage;
    }

    return estimationResult.fortyEightMonthsMessage;

  }

  resultClass(result: string): string {
    return result === 'SUCCESS' ? 'color:green' : 'color:red';
  }

  euro(amount: number): string {
    return isNumber(amount) ? `EUR ${Number(amount).toFixed(2)}` : '--,--';
  }

}
